<template>
  <div class="container">
    <My-Breadcrumb :breadcrumbs="breadcrumbs" />
    <div class="mainBox">
      <!-- 控制区域 -->
      <div class="control_box">
        <div class="control_box_top">
          <!-- 这个页面的时间选择器比较特殊就不用封装的搜索组件  :disabledDate="rangeLimit"-->
          <a-range-picker
            @change="onChangeTimeRange"
            :placeholder="['开始时间', '结束时间']"
            v-model="timeData"
            :allowClear="false"
            style="margin-right:10px"
          />
          <a-button
            type="primary"
            icon="search"
            style="margin-right:10px"
            @click="getInstReportFn"
          >生成</a-button>
          <a-button icon="sync" @click="reflashFn">刷新</a-button>
        </div>
        <div class="control_box_bottom">
          <a-button
            type="primary"
            icon="printer"
            @click="downloadExcel"
            :disabled="tableData.length == 0 || loading"
          >导出</a-button>
        </div>
      </div>
      <!-- 内容区域 -->
      <div class="show_box">
        <a-table
          :loading="loading"
          :columns="columns"
          :data-source="tableData"
          bordered
          :pagination="false"
        />
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { batchingReport, userLog } from "@/request/api";
import moment from "moment";
//引入封装的组件
import SearchBar from "@/components/common/SearchBar.vue";
import MyBreadcrumb from "@/components/common/MyBreadcrumb.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { SearchBar, MyBreadcrumb },
  data() {
    // 表格的列配置
    const columns = [
      {
        title: "原料类型",
        colSpan: 1,
        dataIndex: "goodType",
        customRender: (value, row, index) => {
          let tableLength = this.tableDataLength;
          const obj = {
            children: value,
            attrs: {},
          };
          if (row.goodTitle == "") {
            obj.attrs.colSpan = 2;
          }
          if (row.key === tableLength) {
            obj.attrs.colSpan = 0;
          }
          return obj;
        },
      },
      {
        title: "原料名称",
        dataIndex: "goodTitle",
        customRender: (value, row, index) => {
          const obj = {
            children: value,
            attrs: {},
          };
          return obj;
        },
      },
      {
        title: "消耗量",
        dataIndex: "num",
        customRender: (value, row, index) => {
          const obj = {
            children: value,
            attrs: {},
          };
          return obj;
        },
      },
      {
        title: "消耗明细",
        dataIndex: "menuRelStr",
        customRender: (value, row, index) => {
          const obj = {
            children: value,
            attrs: {},
          };
          return obj;
        },
      },
    ];

    return {
      breadcrumbs: [
        {
          key: 0,
          title: "用餐管理",
        },
        {
          key: 1,
          title: "原料统计",
        },
      ],
      timeParam: {
        begin_date: moment().format("YYYY-MM-DD"),
        end_date: moment().format("YYYY-MM-DD"),
      },
      tableData: [], //从接口请求回来并在js部分整理好的表格数据
      tableDataLength: 0,
      loading: false,
      columns,
      timeData: [
        moment(this.getCurrentData(), "YYYY-MM-DD"),
        moment(this.getCurrentData(), "YYYY-MM-DD"),
      ],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    moment,
    //可选时间限制(仅当天之前的31天内可选)
    // rangeLimit(time) {
    //   // console.log(time)
    //   if (!time) {
    //     return false;
    //   } else {
    //     return time < moment(this.timeParam.begin_date).subtract(31, "days") || time > moment();
    //     // return time < this.startMoment.subtract(31, "days") || time > this.startMoment;
    //     // return time > moment();

    //   }
    // },
    //列表下载
    downloadExcel() {
      this.$confirm({
        title: "确定导出表格?",
        okText: "确定",
        cancelText: "取消",
        onOk: () => {
          this.export2Excel();
        },
        onCancel: () => {},
      });
    },
    //数据写入excel
    export2Excel() {
      var that = this;
      require.ensure([], () => {
        const { export_json_to_excel } = require("@/excel/export2Excel"); //这里必须使用绝对路径，使用@/+存放export2Excel的路径
        const tHeader = [ "原料名称","原料类别", "消耗量",'消耗明细']; // 导出的表头名信息
        const filterVal = [
          "goodTitle",
          "goodType",
          "num",
          "menuRelStr"
        ]; // 导出的表头字段名，需要导出表格字段名
        const list = that.tableData;
        const data = that.formatJson(filterVal, list);

        const { begin_date, end_date } = this.timeParam;
        const fileName = begin_date === end_date ? `原料统计${end_date}` : `原料统计${begin_date}至${end_date}`;
        export_json_to_excel(tHeader, data, fileName); // 导出的表格名称已按日期条件追加搜索时间
        // this.userLogFn()
      });
    },
    //格式转换
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    // 刷新
    reflashFn() {
      this.timeData = [
        moment(this.getCurrentData(), "YYYY-MM-DD"),
        moment(this.getCurrentData(), "YYYY-MM-DD"),
      ];
      this.timeParam = {
        begin_date: moment().format("YYYY-MM-DD"),
        end_date: moment().format("YYYY-MM-DD"),
      };
      this.getInstReportFn();
    },
    getCurrentData() {
      return new Date().toLocaleDateString();
    },
    //获取表格数据
    getInstReportFn() {
      this.loading = true;
      batchingReport(this.timeParam).then((res) => {
        //整理接口返回的数据
        let resultData = res.data.result,
          meals = [];
          // stores = [],
          // expenses = [];
          
          // resultData.expenses.length == 0 &&
          // resultData.stores.length == 0 &&
        if (
          resultData.meals.length == 0
        ) {
          this.loading = false;
          this.tableData = [];
          return;
        }
        // if (resultData.stores.length > 0) {
        //   stores = resultData.stores.map((item) => {
        //     item = {
        //       consumptionType: "小卖部",
        //       goodType: item.goods_type,
        //       goodTitle: item.goods_title,
        //       num: item.num,
        //     };
        //     return item;
        //   });
        // }
        if (resultData.meals.length > 0) {
          meals = resultData.meals.map((item) => {
            item = {
              consumptionType: "用餐",
              goodType: item.batching_type.title,
              goodTitle: item.title,
              num: item.menu_rel_count+item.unit,
              menuRelStr: item.menu_rel_str,
            };
            return item;
          });
        }
        // if (resultData.expenses.length > 0) {
        //   expenses = resultData.expenses.map((item) => {
        //     item = {
        //       consumptionType: "临时消费",
        //       goodType: item.type_name,
        //       goodTitle: "",
        //       num: item.num,
        //     };
        //     return item;
        //   });
        // }
        // let totalObj = {
        //     consumptionType: "合计（全部人员）",
        //     goodType: "",
        //     goodTitle: "",
        //     // num: resultData.total_num,
        //   },
        this.formatData = meals;//stores.concat(meals).concat(expenses),
        // let key = 1;
        // formatData.push(totalObj);
        this.formatData.map((item,index) => {
          item.key = index;
          return item;
        });
        this.loading = false;        
        this.tableData = this.formatData;
        this.tableDataLength = this.formatData.length;
      }).finally(()=>{
        this.loading = false;
      });
    },
    //时间选择
    onChangeTimeRange(date, dateString) {
      let startDate = new Date(dateString[0]).getTime(),
        endDate = new Date(dateString[1]).getTime();
      if (startDate + 3600 * 1000 * 24 * 30 < endDate) {
        this.timeData = [
          moment(this.getCurrentData(), "YYYY-MM-DD"),
          moment(this.getCurrentData(), "YYYY-MM-DD"),
        ];
        this.timeParam = {
          begin_date: moment().format("YYYY-MM-DD"),
          end_date: moment().format("YYYY-MM-DD"),
        };
        this.$message.info("日期范围最大为31天");
      } else {
        this.timeParam = {
          begin_date: dateString[0],
          end_date: dateString[1],
        };
      }
    },

    // userLogFn(){
    //   let moduleId = this.$route.meta.moduleId,
    //       param = {
    //         begin_date:this.timeParam.begin_date,
    //         end_date:this.timeParam.end_date,
    //         total:this.tableData.length
    //       };
    //   userLog(moduleId,param).then(res => {}).catch(err => {
    //     console.log(err)
    //   })
    // },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getInstReportFn();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.mainBox {
  .control_box {
    background-color: white;
    padding: 20px;
    .control_box_bottom {
      margin-top: 20px;
    }
  }
  .show_box {
    width: 100%;
    padding-top: 10px;
  }
}

//修改列表文字、背景颜色
/deep/.ant-table-tbody > tr > td {
  // border-bottom: 10px solid #f0f2f5 !important;
  background: white !important;
}
</style>